import type { TFunction } from 'i18next';

import { Session } from '@feathr/blackbox';
import { toast } from '@feathr/components';

export async function handleLogOut(t: TFunction): Promise<void> {
  try {
    await Session.logOut(() => {
      window.location.assign(
        `${Session.logInUrl}?from=${encodeURIComponent(window.location.href)}`,
      );
    });
  } catch (error) {
    toast(t('There was an error logging out.'), {
      type: 'error',
    });
  }
}
